const bottomLayerZIndex = 3
const bottomMidLayerZIndex = 4
const middleLayerZIndex = 5
const middleTopLayerZIndex = 6
const topLayerZIndex = 7

export const getOutroImages = width => [
  {
    src: '/images/clubhouse/outro/outro-1.png',
    alt: 'Outro 1',
    top: ['unset', 'unset', '-3%'],
    bottom: ['-1%', '-1%', 'unset'],
    left: ['-1%', '-1%', '-5%'],
    zIndex: middleLayerZIndex,
  },
  {
    src: '/images/clubhouse/outro/outro-2.png',
    alt: 'Outro 2',
    top: ['2%', '2%', '30%'],
    left: ['-3%', '-3%', '-5%'],
    zIndex: middleLayerZIndex,
  },
  {
    src: '/images/clubhouse/outro/outro-3.png',
    alt: 'Outro 3',
    top: ['unset', 'unset', '-5%'],
    bottom: ['13%', '13%', 'unset'],
    left: ['-5%', '-5%', width > 1650 ? '50vw' : '43%'],
    zIndex: topLayerZIndex,
    maxWidthDesktop: 'min(250px, 40vw)',
  },
  {
    src: '/images/clubhouse/outro/outro-4.png',
    alt: 'Outro 4',
    top: ['unset', 'unset', '8%'],
    bottom: ['20%', '20%', 'unset'],
    left: ['30%', '30%', 'unset'],
    right: ['unset', 'unset', '22%'],
    zIndex: [topLayerZIndex, topLayerZIndex, middleLayerZIndex],
  },
  {
    src: '/images/clubhouse/outro/outro-5.png',
    alt: 'Outro 5',
    bottom: ['-3%', '-3%', '45%'],
    left: ['35%', '35%', width > 1650 ? '40%' : '40%'],
    zIndex: [middleLayerZIndex, middleLayerZIndex, topLayerZIndex],
  },
  {
    src: '/images/clubhouse/outro/outro-6.png',
    alt: 'Outro 6',
    bottom: ['8%', '8%', '40%'],
    left: ['25%', '25%', 'unset'],
    right: ['unset', 'unset', '25%'],
    zIndex: [bottomLayerZIndex, bottomLayerZIndex, middleTopLayerZIndex],
  },
  {
    src: '/images/clubhouse/outro/outro-7.png',
    alt: 'Outro 7',
    top: ['3%', '3%', '25%'],
    left: ['20%', '20%', 'unset'],
    right: ['unset', 'unset', '12%'],
    zIndex: [bottomLayerZIndex, bottomLayerZIndex, middleLayerZIndex],
  },
  {
    src: '/images/clubhouse/outro/outro-8.png',
    alt: 'Outro 8',
    bottom: ['-1%', '-1%', '11%'],
    right: ['2%', '2%', '28%'],
    zIndex: topLayerZIndex,
    maxWidthDesktop: 'min(280px, 20vw)',
  },
  {
    src: '/images/clubhouse/outro/outro-9.png',
    alt: 'Outro 9',
    bottom: ['12%', '12%', '20%'],
    right: ['-1%', '-1%', '10%'],
    zIndex: [middleLayerZIndex, middleLayerZIndex, middleTopLayerZIndex],
  },
  {
    src: '/images/clubhouse/outro/outro-10.png',
    alt: 'Outro 10',
    top: ['-5%', '-5%', '-5%'],
    bottom: ['unset', 'unset', 'unset'],
    left: ['unset', 'unset', 'unset'],
    right: ['-5%', '-5%', '-5%'],
    zIndex: [topLayerZIndex, topLayerZIndex, bottomMidLayerZIndex],
    maxWidthDesktop: 'min(160px, 25vw)',
  },
  {
    src: '/images/clubhouse/outro/outro-11.png',
    alt: 'Outro 11',
    display: ['none', 'none', 'block'],
    top: 'unset',
    bottom: ['unset', 'unset', '-2%'],
    left: 'unset',
    right: ['unset', 'unset', '-2%'],
    zIndex: bottomLayerZIndex,
  },
]
